import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format, formatISO } from "date-fns";

const Accreditations: FC = () => {
    return (
      <Box mt={1}>
        <Header>
            <Box display={'flex'}>
                <Typography mb={1} ml={40}>Специальность</Typography>
                <Typography mb={1} ml={40}>Дата выдачи</Typography>
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "700px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "700px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "700px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "700px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "700px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "700px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
            <Box display='flex'>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{width: "700px", mr: 1, mb: 1 }}
                />
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1 }}
                />
            </Box>
        </Header>
        <Body>
            <TextField 
                label="Номер свидетельства об аккредитации"
                variant="outlined"
                size="small"
                sx={{ width: "600px", mb: 1 }}
            />
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Вид аккредитации</Typography>
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mb: 1, mr: 1, ml: 16.2}}
                />
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "600px", mb: 1 }}
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Специальность</Typography>
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mb: 1, mr: 1, ml: 19}}
                />
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "600px", mb: 1, mr: 1}}
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Наименование профессионального <br /> стандарта</Typography>
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "150px", mb: 1, mr: 1}}
                />
                <TextField 
                    variant="outlined"
                    size="small"
                    sx={{ width: "600px", mb: 1, mr: 1 }}
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Протокол заседания аккредитационной комиссии</Typography>
                <TextField 
                    label="Номер"
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, mr: 1}}
                />
                <TextField 
                    label="Дата"
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mb: 1, mr: 1 }}
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={3} ml={1}>Место проведения аккредитации</Typography>
                <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: "759px", mb: 1, mr: 1 }}
                />
            </Box>
            <Box display="flex" alignItems="center">
                <Typography mr={1} ml={1}>Решение аккредитационной комиссии действительно до</Typography>
                <TextField
                    value={format(1683886255004, "dd.MM.yyyy")}
                    variant="outlined"
                    size="small"
                    sx={{ width: "200px", mr: 1}}
                />
            </Box>
        </Body>
      </Box>
    );
  };

export default Accreditations;

